import { useBillingSettings } from '@/hooks/useBilling';
import { DEFAULT_CURRENCY } from '@/lib/money';

export function useCurrency() {
  const { data, isLoading, error } = useBillingSettings();

  return {
    currency: data?.currency ?? DEFAULT_CURRENCY,
    isLoading,
    error,
  };
}
